import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Box, CircularProgress } from '@mui/material';
import { initializeAuth } from './services/authService';
import AppContent from './components/AppContent';

// Create a client
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes (renamed from cacheTime in v5)
        },
    },
});

const App: React.FC = () => {
    const [authInitialized, setAuthInitialized] = useState(false);

    useEffect(() => {
        const initAuth = async () => {
            const isAuthenticated = await initializeAuth();
            
            // Dispatch the appropriate auth event based on the result
            if (isAuthenticated) {
                window.dispatchEvent(new CustomEvent('auth:login'));
            } else {
                window.dispatchEvent(new CustomEvent('auth:logout'));
            }
            
            // Then dispatch initialization complete event
            window.dispatchEvent(new CustomEvent('auth:initialized'));
            setAuthInitialized(true);
        };
        
        initAuth();
    }, []);

    if (!authInitialized) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    //minHeight: '100vh',
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <QueryClientProvider client={queryClient}>
            <Router>
                <AppContent />
            </Router>
        </QueryClientProvider>
    );
};

export default App;
